import { isDemoMode } from '@utils/demo'

export function useDemo() {
  return isDemoMode()
}
